'use client';
export default function Footer() {
  return (
    <footer id="footer-1" style={{ backgroundColor: '#1a1a1a' }} className="pt-16 pb-0">
      <div className="max-w-7xl mx-auto px-4">
        {/* FOOTER CONTENT */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 pb-12">
          {/* FOOTER INFO */}
          <div>
            {/* Logo */}
            <div className="flex items-center gap-2 mb-5">
              <img
                src="/assets/images/logo-cosa-dark.png"
                alt="COSA – Compagnie de Santé Africaine"
                style={{ height: 56, width: 'auto', maxWidth: 180, objectFit: 'contain', display: 'block' }}
              />
            </div>

            <p className="text-sm mb-5" style={{ color: '#aaa', lineHeight: '1.7' }}>
              Centre médical innovant de haute qualité à Yopougon Ananeraie, offrant des soins médicaux et biomédicaux accessibles à tous, conformes aux standards internationaux.
            </p>

            {/* Social Icons */}
            <div className="flex gap-3">
              {[
                { icon: 'fab fa-facebook-f', label: 'Facebook' },
                { icon: 'fab fa-twitter', label: 'Twitter' },
                { icon: 'fab fa-linkedin-in', label: 'LinkedIn' },
                { icon: 'fab fa-instagram', label: 'Instagram' },
              ]?.map((social, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label={social?.label}
                  className="w-9 h-9 rounded-full flex items-center justify-center text-sm transition-all"
                  style={{ backgroundColor: 'rgba(255,255,255,0.1)', color: '#aaa' }}
                  onMouseEnter={e => {
                    e.currentTarget.style.backgroundColor = '#0e5932';
                    e.currentTarget.style.color = '#fff';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)';
                    e.currentTarget.style.color = '#aaa';
                  }}
                >
                  <i className={social?.icon}></i>
                </a>
              ))}
            </div>
          </div>

          {/* LOCATION */}
          <div>
            <h5 className="font-bold text-base text-white mb-5" style={{ fontFamily: 'Lato, sans-serif' }}>
              Notre Localisation
            </h5>
            <p className="text-sm mb-1" style={{ color: '#aaa' }}>Yopougon Ananeraie,</p>
            <p className="text-sm mb-4" style={{ color: '#aaa' }}>Abidjan, Côte d'Ivoire</p>
            <p className="text-sm mb-1" style={{ color: '#aaa' }}>
              E:{' '}
              <a
                href="mailto:contact@cosa-sante.ci"
                className="transition-colors"
                style={{ color: '#fbaf45' }}
                onMouseEnter={e => (e.currentTarget.style.color = '#e89a2a')}
                onMouseLeave={e => (e.currentTarget.style.color = '#fbaf45')}
              >
                contact@cosa-sante.ci
              </a>
            </p>
            <p className="text-sm" style={{ color: '#aaa' }}>T: +225 00 00 00 00</p>
          </div>

          {/* WORKING TIME */}
          <div>
            <h5 className="font-bold text-base text-white mb-5" style={{ fontFamily: 'Lato, sans-serif' }}>
              Horaires d'Ouverture
            </h5>
            {[
              ['Lun - Mer', '8:00 - 19:00'],
              ['Jeudi', '8:00 - 18:30'],
              ['Vendredi', '8:00 - 18:00'],
              ['Sam - Dim', 'Fermé'],
            ]?.map(([day, time], i) => (
              <p key={i} className="text-sm mb-1" style={{ color: '#aaa' }}>
                {day} -{' '}
                <span style={{ color: '#ccc' }}>{time}</span>
              </p>
            ))}
          </div>

          {/* EMERGENCY */}
          <div>
            <h5 className="font-bold text-base text-white mb-5" style={{ fontFamily: 'Lato, sans-serif' }}>
              Urgences Médicales
            </h5>
            <div
              className="text-2xl font-black mb-3"
              style={{ color: '#fbaf45', fontFamily: 'Lato, sans-serif' }}
            >
              +225 00 00 00 00
            </div>
            <p className="text-sm" style={{ color: '#aaa', lineHeight: '1.7' }}>
              Notre équipe est disponible pour les urgences et les évacuations sanitaires en partenariat avec les services et autorités locales.
            </p>
          </div>
        </div>

        {/* COPYRIGHT */}
        <div
          className="py-5 text-center"
          style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}
        >
          <p className="text-sm" style={{ color: '#666' }}>
            &copy; 2025 <span style={{ color: '#fbaf45' }}>COSA</span> — Compagnie de Santé Africaine. Tous droits réservés. Propriété de <span style={{ color: '#aaa' }}>Concept Labo</span>.
          </p>
        </div>
      </div>
    </footer>
  );
}
